/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import Vue from 'vue';

export default new Vue({
  data() {
    return {
      legends: [],
      allSelect: false,
      allClear: false
    };
  },
  methods: {
    setLegends(legends) {
      this.$set(this, 'legends', legends);
    },
    toggleLegend(name) {
      const { legends } = this;
      const legend = legends.find(l => l.name === name);

      if (legend.visible) {
        legend.visible = false;
        this.allClear = false;
        this.allSelect = false;
      } else {
        legend.visible = true;
        this.allClear = false;
        this.allSelect = false;
      }

      this.$emit('toggleLegend');
    },
    selectStatus(status) {
      const { legends } = this;

      switch (status) {
        case 'clear':
          if (this.allClear) {
            this.allClear = true;
            this.allSelect = false;
          } else {
            this.allClear = true;
            this.allSelect = false;
          }
          for (const x in legends) {
            legends[x].visible = false;
          }

          break;
        case 'all':
          if (this.allSelect) {
            this.allClear = false;
            this.allSelect = true;
          } else {
            this.allClear = false;
            this.allSelect = true;
          }
          for (const x in legends) {
            legends[x].visible = true;
          }
          break;
        default:
      }

      this.$emit('toggleLegend');
    }
  }
});
